export default __webpack_public_path__ + "static/media/1-coastline.799e9ebf.png";